import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/navbar/general/Navbar';
import image1 from '../../images/Resort.png';
import HeroSection from '../../components/ClientPage/HeroSection';
import IconStrip from '../../components/ClientPage/IconStrip';
import Modal from '../../components/ClientPage/Modal';
import ImageGallery from '../../components/ClientPage/ImageGallery';
import '../../components/Styles/ClientPage.css';

const ClientPage = () => {
  const location = useLocation();
  const { venueid } = location.state || {};
  const [venueDetails, setVenueDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  useEffect(() => {
    if (venueid) {
      const fetchVenueDetails = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_API_URL}/getbyvenueid?venueid=${venueid}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
            }
          );

          if (response.ok) {
            const data = await response.json();
            setVenueDetails(data);
          } else {
            console.error('Failed to fetch venue details:', response.status);
          }
        } catch (error) {
          console.error('Error fetching venue details:', error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchVenueDetails();
    }
  }, [venueid]);

  return (
    <div className="client-page">
      <Navbar />
      <div className="client-page__content">
        <HeroSection toggleModal={toggleModal} imageSrc={image1} venueDetails={venueDetails} />
        <IconStrip venueDetails={venueDetails} />
        <ImageGallery venueDetails={venueDetails} />
        <Modal isOpen={isModalOpen} toggleModal={toggleModal} />
      </div>
    </div>
  );
};

export default ClientPage;
